import { insurancePreQuestionnaire_Form } from './selectors';
import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { ComponentBase } from '../../../../views/component-base';
import { MemberPortalSharedState } from '../../store/shared.states';
import { Router } from '@angular/router';
import { memberAccountDropdown_SelectedAccount } from '../member-account-dropdown/selectors';
import {
  commomState_SystemConfig_Config,
  commomState_SystemConfig_Messages,
} from 'src/app/store/common/common.selectors';
import { AppState } from 'src/app/store/app.states';
import { ShowStartQuestionnaireRequestAction } from './actions';
import { NgIf, AsyncPipe } from '@angular/common';
import {
  EntryFieldRadioComponent,
  AppButtonComponent,
} from '@ifaa-components/ui-components';
import { NgrxFormsModule } from 'ngrx-forms';
import { AppRadioDirective } from '../../directives/app-radio.directive';
import { InputScrollDirective } from '../../directives/input-scroll.directive';
import { MessagePipe } from '../../pipes/message';
import { BannerComponent } from '../banner/banner.component';

@Component({
  selector: 'app-insurance-pre-questionnaire',
  templateUrl: './insurance-pre-questionnaire.component.html',
  styleUrls: ['./insurance-pre-questionnaire.component.scss'],
  imports: [
    NgrxFormsModule,
    NgIf,
    AsyncPipe,
    MessagePipe,
    EntryFieldRadioComponent,
    InputScrollDirective,
    AppRadioDirective,
    AppButtonComponent,
    BannerComponent
  ],
})
export class InsurancePreQuestionnaireComponent
  extends ComponentBase
  implements OnInit, OnDestroy
{
  selectedAccount$ = this.store.pipe(
    select(memberAccountDropdown_SelectedAccount)
  );
  tenantConfig$ = this.appstore.pipe(select(commomState_SystemConfig_Config));
  messages$ = this.appstore.pipe(select(commomState_SystemConfig_Messages));
  form$ = this.store.pipe(select(insurancePreQuestionnaire_Form));

  constructor(
    public store: Store<MemberPortalSharedState>,
    public appstore: Store<AppState>,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();

    this.sub = this.selectedAccount$.subscribe((x) => {
      if (x) {
      }
    });
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

  onStartClick() {
    this.dispatch(
      this.store,
      ShowStartQuestionnaireRequestAction({ display: true })
    );
  }
}
